import React from 'react'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { FormCard } from '@lmc/ui-kit'
import dayjs from 'dayjs'

type DeliveryDetailContentProps = {
  record: any
  medicationName: string
}

export const DeliveryDetailContent: React.FC<DeliveryDetailContentProps> = ({
  record
}) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  const description = record?.description || record?.title || ''
  const previousExpectedStock =
    record?.previousExpectedStock || record?.amount2 || 0
  const receivedStock = record?.receivedStock || record?.amount1 || 0
  const expectedStock = record?.expectedStock || record?.amount2 || 0
  const stockUnit =
    record?.stockUnit || record?.stockQuantityType || t('TABLETS')

  const receivedBy = record?.receivedBy || record?.loggedBy
  const receivedByName = receivedBy
    ? `${receivedBy.name?.first || ''} ${receivedBy.name?.last || ''}`.trim()
    : ''
  const receivedDate = record?.receivedDate || record?.timeLogged
  const receivedDateFormatted = receivedDate
    ? dayjs(receivedDate).format('DD-MM-YYYY')
    : ''
  const receivedFrom = record?.receivedFrom || ''

  return (
    <FormCard level={2}>
      <InfoRow>
        <FullWidthSection>
          <StyledLabel level={2}>{t('DESCRIPTION')}</StyledLabel>
          <Text>{description || '-'}</Text>
        </FullWidthSection>
      </InfoRow>
      <InfoRow>
        <InfoSection>
          <StyledLabel level={2}>{t('PREVIOUS_EXPECTED_STOCK')}</StyledLabel>
          <Text weight="bold">
            {previousExpectedStock !== undefined
              ? `${previousExpectedStock} ${stockUnit}`
              : '-'}
          </Text>
        </InfoSection>
        <InfoSection>
          <StyledLabel level={2}>{t('RECEIVED_STOCK')}</StyledLabel>
          <Text weight="bold">
            {receivedStock !== undefined
              ? `${receivedStock} ${stockUnit}`
              : '-'}
          </Text>
        </InfoSection>
        <InfoSection>
          <StyledLabel level={2}>{t('EXPECTED_STOCK')}</StyledLabel>
          <Text weight="bold">
            {expectedStock !== undefined
              ? `${expectedStock} ${stockUnit}`
              : '-'}
          </Text>
        </InfoSection>
      </InfoRow>
      <InfoRow>
        <InfoSection>
          <StyledLabel level={2}>{t('RECEIVED_BY')}</StyledLabel>
          <Text weight="bold">{receivedByName || '-'}</Text>
        </InfoSection>
        <InfoSection>
          <StyledLabel level={2}>{t('RECEIVE_DATE')}</StyledLabel>
          <Text weight="bold">{receivedDateFormatted || '-'}</Text>
        </InfoSection>
        <InfoSection>
          <StyledLabel level={2}>{t('RECEIVED_FROM')}</StyledLabel>
          <Text weight="bold">{receivedFrom || '-'}</Text>
        </InfoSection>
      </InfoRow>
    </FormCard>
  )
}

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
`

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 185px;
`

const FullWidthSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledLabel = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`
